import { dataTimes } from 'dls-icons-data'
import { createIcon } from '../common'

const IconTimes = /*#__PURE__*/createIcon(dataTimes)
export default IconTimes
